module.exports = __webpack_public_path__ + "img/success_icon.92f2a57f.png";